import React from "react";
import { DatePicker } from "antd";

const { RangePicker } = DatePicker;

const DepartmentDatePicker = ({ onChange, value }) => {
  return (
    <RangePicker
      value={value}
      onChange={onChange}
      style={{ height: "38px" }}
    />
  );
};

export default DepartmentDatePicker;